<div #uebersichtFooter [class]="extraCss" class="fixed-bottom" id="app-footer">
  <footer class="dna-footer common-ui-footer">
    <div class="mb-3x">
      <span class="float-left">{{ 'COMMON_UI.FOOTER.COPYRIGHT' | translate }}</span>
      <a class="ml-3x float-right" [href]="imprintLink" rel="noopener noreferrer"
         target="_blank"
         title="{{ 'COMMON_UI.FOOTER.IMPRINT' | translate }}">{{ 'COMMON_UI.FOOTER.IMPRINT' | translate }}
      </a>
      <a class="ml-3x float-right" [href]="privacyLink" rel="noopener noreferrer"
         target="_blank"
         title="{{ 'COMMON_UI.FOOTER.PRIVACY' | translate }}">{{ 'COMMON_UI.FOOTER.PRIVACY' | translate }}
      </a>
      <a class="float-right" routerLink="/license" target="_blank"
         title="{{ 'COMMON_UI.FOOTER.LICENSE' | translate }}">{{ 'COMMON_UI.FOOTER.LICENSE' | translate }}
      </a>
    </div>
  </footer>
</div>
